module.exports = __webpack_public_path__ + "img/commandImg3.fb9dd960.png";